<template>
    <v-layout justify-center>
        <v-flex xs12 sm10>
            <!-- How much Die -->
            <v-row justify="end" class="mr-3">
                <div style="margin-right: 4%"
                     :style="$vuetify.breakpoint.mdAndUp ? {'font-size':'24px'}:{'font-size':'20px'}"
                >จำนวนผู้เสียชีวิตทั้งหมด</div>
                <div style="color: #006738;font-weight: bold"
                     :style="$vuetify.breakpoint.mdAndUp ? {'font-size':'24px'}:{'font-size':'20px'}"
                >{{allPatient.length}} ราย</div>
            </v-row>
            <v-simple-table
                    id="customer-table"
                    style="text-align: center"
                    v-if="typetable == false"
                    :class="{'customer-table-sm': $vuetify.breakpoint.smAndDown }"
                    class="mt-2 mb-5"
                >
                <template style="max-width: 100%">
                    <thead>
                    <tr>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ลำดับ</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >เพศ</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >อายุ</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ยานพาหนะ</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >แขวง</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >เขต</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ละติจูด</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ลองติจูด</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >วัน</th>
                        <th
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >เวลา</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in allPatient" :key="index" >
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{ ((Pagination.page - 1) * Pagination.itemsPerPage) + index + 1 }}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.sex ? (item.sex):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.age ? (item.age):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.car_band ? (item.car_band):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.acc_subdist ? (item.acc_subdist):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.acc_dist ? (item.acc_dist):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.acc_lat ? (item.acc_lat):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.acc_long ? (item.acc_long):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.acc_date | moment('DD/MM/YYYY') }}</td>
                        <td style="border-right: white"
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '12px'}"
                        >{{item.acc_time | moment('HH.mm') }} น.</td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
            <v-data-table
                    :items="allPatient"
                    id="customer-table"
                    style="text-align: center"
                    :class="{'customer-table-sm': $vuetify.breakpoint.smAndDown }"
                    class="mt-2 mb-5"
                    v-if="typetable == true"
                    :options.sync="Pagination"
                    hide-default-header
            > <!--                        @page-count="pageCount = $event"-->
                <template v-slot:header="{}">
                    <tr>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ลำดับ</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >เพศ</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >อายุ</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ยานพาหนะ</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >แขวง</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >เขต</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ละติจูด</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >ลองติจูด</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >วัน</th>
                        <th
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '10px'}"
                        >เวลา</th>
                    </tr>
                </template>

                <template v-slot:item="{item,index}" >
                    <tr>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{ ((Pagination.page - 1) * Pagination.itemsPerPage) + index + 1 }}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.sex ? (item.sex):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.age ? (item.age):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.car_band ? (item.car_band):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.acc_subdist ? (item.acc_subdist):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.acc_dist ? (item.acc_dist):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.acc_lat ? (item.acc_lat):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.acc_long ? (item.acc_long):'-'}}</td>
                        <td
                                :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.acc_date | moment('DD/MM/YYYY') }}</td>
                        <td style="border-right: white"
                            :style="$vuetify.breakpoint.mdAndUp ? {'font-size': '16px'}:{'font-size': '14px'}"
                        >{{item.acc_time | moment('HH.mm') }} น.</td>
                    </tr>
                </template>

            </v-data-table>

            <v-row style="max-width: 100%" justify="end" >
                <v-btn
                        dark
                        style="background-color:#006738"
                        @click="saveAsExcel"
                        max-width="110px"
                >Export</v-btn>
            </v-row>
        </v-flex>
<!--        <v-flex  v-else>-->
<!--            <v-row justify="end" class="mr-1">-->
<!--                <div style="margin-right: 4%"-->
<!--                     :style="$vuetify.breakpoint.mdAndUp ? {'font-size':'24px'}:{'font-size':'20px'}"-->
<!--                >จำนวนผู้เสียชีวิตทั้งหมด</div>-->
<!--                <div style="color: #006738;font-weight: bold"-->
<!--                     :style="$vuetify.breakpoint.mdAndUp ? {'font-size':'24px'}:{'font-size':'20px'}"-->
<!--                >57 ราย</div>-->
<!--            </v-row>-->
<!--            <v-data-table-->
<!--                    :items="allPatient.data"-->
<!--                    hide-default-footer-->
<!--                    id="customersm"-->
<!--                    class="mt-2"-->
<!--            > &lt;!&ndash;                        @page-count="pageCount = $event"&ndash;&gt;-->
<!--                <template v-slot:header="{}">-->
<!--                    <tr>-->
<!--                        <th width="10%">ลำดับ</th>-->
<!--                        <th width="25%">เพศ</th>-->
<!--                        <th width="14%">อายุ</th>-->
<!--                        <th width="19%">วัน</th>-->
<!--                        <th width="21%">เวลา</th>-->
<!--                    </tr>-->
<!--                </template>-->

<!--                <template v-slot:item="{item,index}" >-->
<!--                    <tr>-->
<!--                        <td>{{ ((allPatient.current_page - 1) * allPatient.per_page) + index + 1 }}</td>-->
<!--                        <td>{{item.sex ? 'หญิง':'ชาย'}}</td>-->
<!--                        <td>{{item.age}}</td>-->
<!--                        <td>{{item.created_at | moment('DD/MM') }}</td>-->
<!--                        <td style="border-right: white">{{item.created_at | moment('HH.mm') }}</td>-->
<!--                    </tr>-->
<!--                </template>-->
<!--            </v-data-table>-->
<!--            <v-pagination-->
<!--                    v-model="allPatient.current_page"-->
<!--                    :length="allPatient.last_page"-->
<!--                    @input="onGetAllPatient"-->
<!--                    class="mt-7 pagination"-->
<!--                    color="#006738"-->
<!--            ></v-pagination>-->
<!--        </v-flex>-->
    </v-layout>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import XLSX from 'xlsx'
    export default {
        name: "TablePatient",
        data: ()=>({
            typetable: true,
            Pagination: {
                page: 1,
                itemsPerPage: 10
            },
        }),
        computed: {
            ...mapState({
                allPatient: state => state.patient.allPatient,
            })
        },
        methods: {
            ...mapActions('patient',['onGetPatient']),
            onBack() {
                this.$router.push("/")
            },
            testtable() {
                this.typetable = false;
            },
            async saveAsExcel() {
                await this.testtable();
                let workbook = XLSX.utils.book_new();

                //var worksheet_data  =  [['hello','world']];
                //var worksheet = XLSX.utils.aoa_to_sheet(worksheet_data);



                let worksheet_data  = document.getElementById("customer-table");
                let worksheet = XLSX.utils.table_to_sheet(worksheet_data);



                workbook.SheetNames.push("Patient");
                workbook.Sheets["Patient"] = worksheet;
                this.typetable = true;
                return XLSX.writeFile(workbook, "AllPatients.xlsx");


            },

        }
    }
</script>

<style scoped>


</style>
